/**
 * El salvavidas: si una pantalla se rompe al pintarse, se rompe ELLA, no el Studio entero.
 *
 * POR QUÉ EXISTE. Hasta el 11-sep-2026 una respuesta del motor con la forma equivocada dejaba el
 * panel en negro: ni barra, ni cabecera, ni un mensaje. El autor no sabía si había perdido su
 * trabajo. React solo recoge los fallos de pintado con un componente de clase como este.
 *
 * Va en dos sitios: alrededor del lienzo —la barra y la cabecera siguen vivas y puedes irte a otra
 * sección— y alrededor de toda la app, por si lo que falla es la barra misma. `clave` lo reinicia:
 * al cambiar de sección se vuelve a intentar pintar, en vez de quedarse con el error puesto.
 *
 * No manda el error a ningún servidor: el mensaje puede llevar texto del manuscrito.
 */
import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode; clave?: string; entero?: boolean }
interface Estado { fallo: Error | null }

export default class Salvavidas extends Component<Props, Estado> {
  state: Estado = { fallo: null };

  static getDerivedStateFromError(fallo: Error): Estado {
    return { fallo };
  }

  componentDidCatch(fallo: Error, info: ErrorInfo) {
    // A la consola del navegador, que es donde se mira; a ningún sitio más.
    console.error("[salvavidas]", fallo, info.componentStack);
  }

  componentDidUpdate(antes: Props) {
    if (this.state.fallo && antes.clave !== this.props.clave) this.setState({ fallo: null });
  }

  render() {
    const { fallo } = this.state;
    if (!fallo) return this.props.children;
    const tarjeta = (
      <section className="carta">
        <h2>Esta pantalla no se ha podido pintar<span className="sub">tu trabajo está a salvo</span></h2>
        <p className="vacio">
          Tu manuscrito y tus documentos no se han tocado: esto es un fallo al enseñarlos, no al
          guardarlos. {this.props.entero
            ? "Recarga la página para volver a empezar."
            : "Vete a otra sección desde la barra y vuelve, o recarga la página."}
        </p>
        <p className="vacio mono" style={{ fontSize: 12 }}>{fallo.message}</p>
        <div className="dir">
          <button className="btn" onClick={() => location.reload()}>Recargar</button>
          {!this.props.entero && (
            <button className="btn fantasma" onClick={() => this.setState({ fallo: null })}>Volver a intentarlo</button>
          )}
        </div>
      </section>
    );
    return this.props.entero ? <div className="puerta">{tarjeta}</div> : tarjeta;
  }
}
